//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'LoadingOverlay',

	data() {
		return {
			showLoadingOverlay: false,
		};
	},

	created() {
		this.$nuxt.$on('show-loading-overlay', () => (this.showLoadingOverlay = true));
		this.$nuxt.$on('hide-loading-overlay', () => (this.showLoadingOverlay = false));
	},
};
